// src/pages/AdminMagazinePage.tsx
import React, { useState, useEffect } from 'react';
import { TableMagazine } from '@/components/Magazine/TableMagazine';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { Button } from '@/components/common/Button';
import { getAdminNeighborhoods } from '@/API/apiService';
import { useNavigate } from 'react-router-dom';

interface Magazine {
  id: number;
  date_time: string;
  title: string;
}

export const AdminMagazinePage: React.FC = () => {
  const [magazines, setMagazines] = useState<Magazine[]>([]);
  const navigate = useNavigate();

  // APIから店舗一覧（ネイバーフッド）を取得
  useEffect(() => {
    async function loadMagazines() {
      try {
        const response = await getAdminNeighborhoods();
        // APIのレスポンス構造に合わせて修正してください
        const data: Magazine[] = response.data.data ?? response.data;
        setMagazines(data);
      } catch (error) {
        console.error('店舗一覧の取得に失敗しました:', error);
      }
    }
    loadMagazines();
  }, []);

  // 新規作成ボタンの処理：新規作成画面へ遷移
  const handleCreateNew = () => {
    navigate('/admin/magazine/shop/new');
  };

  return (
    <AdminLayout>
      <div>
        <div className="flex justify-between items-start h-16 mb-6">
          <h2 className="text-xl font-bold">マガジン</h2>
          <Button onClick={handleCreateNew}>新規作成</Button>
        </div>
        <TableMagazine magazines={magazines} />
      </div>
    </AdminLayout>
  );
};

export default AdminMagazinePage;
